/**
 * Remove FT widget if present
 *
 * @returns {undefined}
 */
export function useRemoveGifty() {
	onMounted(() => {
		const giftyWidget = document.getElementById('gifty-container');

		if (giftyWidget) {
			giftyWidget.remove();
		}
	});
}
